export enum VotingStep {
  Athlete = 1,
  Team = 2,
  Coach = 3,
  Young = 4,
  Summary = 5,
}
